import React from "react";
import styled from "styled-components";
import Title from "./Title";
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import { contactAnimation } from "animation";
import ImageGallery from "react-image-gallery";

import party1 from "../assets/kids/party1.jpg";
import home from "assets/oakmont/Picture1.jpg";
import { lightblue } from "./color";
function CaseStudy() {
  const [element, controls] = useScroll();

  return (
    <Section id="case" ref={element}>
      <Title value="Case" />
      <motion.div
        className="contact"
        variants={contactAnimation}
        animate={controls}
        transition={{
          delay: 0.03,
          type: "tween",
          duration: 0.8,
        }}
      >
        <div className="contact__title">
          <h2>Case Study</h2>
          {/* <h3> Case Studay </h3> */}
        </div>
        <div className="contact__data">
          <div className="contact__data__description">
            <p>
              Our job is to make money for you by helping you build and sell our
              new builds.  We do this by helping you do multiple builds per
              year.  Below is a case study done on one of our recent builds.
            </p>

            <p>
              In December 2024 we sold a project to one of our clients.  His
              project was two houses on one section that was subdividable.  His
              plan was to build and sell a minimum of three projects per year.
              His project is due out of council in March 2025 and we already
              have buyers for both houses lined up at $125,000 more per house
              than we are building them for...{" "}
              <strong className="yellow">
                That is a nice $250,000 gross profit for our client from this
                one project.
              </strong>
                The buyers are happy to sign an S&P Agreement once out of
              council, as the build can start and completion is only 2 to 3
              months away.  Once they have signed unconditionally our client can
              get the next project started, which is what he intends to do.
            </p>
            <p className="yellow">
              Our client is over the moon as his plan was to make around
              $500,000 gross profit per year from our builds, so we are off to a
              great start.
            </p>
            <p>
              Our projects sell well as they are way under what a normal house
              would sell for and irresistible to a first home buyer on a
              budget.  In this case our client has built two 80sqm 3 bed houses
              and is selling them for $525,000 each.  On completion each house
              including land will have cost him $400,000. 
            </p>
            <p className="yellow">
              A happy investor creating great homes for first home buyers at an
              affordable price, is the key to success
            </p>
            <br />
          </div>
        </div>
      </motion.div>
    </Section>
  );
}

const Section = styled.section`
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${home}) no-repeat center/cover;
  padding: 5rem 2rem;

.contact {
    color: var(--white-color);
    background: var(--primary-color);
    margin: 4rem auto;
    border: 2px solid ${lightblue};
    border-radius: 10px;
    min-height: auto; /* Adjust height dynamically */
    height: auto; /* Remove fixed height */
    width: 60vw;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    box-shadow: 0px 10px 20px rgba(173, 216, 230, 0.3), /* Soft blue glow */
                0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */

  &__title {
    margin-bottom: 1rem;
      h2 {
        font-size: 2rem;
        color: var(--secondary-color);
      }
      h3 {
        font-size: 3rem;
        color: var(--third-color);
      }
  }
  &__data {
    gap: 2rem;
    &__description {
      // border: 1px solid green;
        margin: 0 rem;
        padding: 0rem;
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 2rem;
        text-align: left;

        p {
          font-size: 1.2rem;
        }

        .yellow {
          color: var(--third-color);
        }

        ul {
          list-style: none;
          padding: 0;
        }

        li {
          font-size: 1.5rem;
          color: var(--third-color);
          margin-bottom: 0.5rem;
        }
    }
    &__form {

      .div{
        background: var(--third-color);
        height: 300px;
      }
      }
    }
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 
  min-height: 180vh;
  .contact {
    width: 95vw;
    min-height: auto;
    height: auto;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    text-align: center;
    &__title {
      margin: 0;
      align-items:center;
      text-align: center;
      p {
        font-size: 0.8rem;
        width: 80%;
      }
      h2 {
        font-size: 1.5rem;
        text-align: center;
      }

      h3 {
        font-size: 2rem;
        text-align: center;
      }
    }
    &__data {
      max-width: 100%;
      p {
        text-align: left;
        width: 80vw;
      }
        &__description {
      padding: 0rem;
      gap: 2rem;
      margin-top: 2rem;
      h4 {
        font-size: 1rem;
        color: var(--secondary-color);
      };

      p {
        text-align: left;
        font-size: 1.1rem;
      }
      div {
        p {
          strong {
            color: var(--third-color);
            font-size: 1.1rem;
          }
        }
      }
    }

      }
    }
  }

  
}


`;

export default CaseStudy;
